import { render } from "./MyStudentGroupsDetailsView.vue?vue&type=template&id=7fa00746"
import script from "./MyStudentGroupsDetailsView.vue?vue&type=script&lang=js"
export * from "./MyStudentGroupsDetailsView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/admin/dev/claire/web/orca-analytics.web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__